import { BackToTopIcon } from '@noah-labs/fe-shared-ui-assets/muiSvgIcons/BackToTopIcon';
import type { PpPrimaryButton } from '@noah-labs/fe-shared-ui-components';
import { PrimaryButton } from '@noah-labs/fe-shared-ui-components';
import { scroller } from 'react-scroll';

function scrollToTop(): void {
  scroller.scrollTo('top', {
    delay: 100,
    duration: 1500,
    smooth: true,
  });
}

export function BackToTopButton(props: PpPrimaryButton): React.ReactElement {
  return (
    <PrimaryButton
      size="small"
      variant="text"
      {...props}
      endIcon={<BackToTopIcon />}
      onClick={(): void => scrollToTop()}
    >
      Back to Top
    </PrimaryButton>
  );
}
